export default "__VITE_PUBLIC_ASSET__7bd84f4b__"